import { Alert, Box } from '@mui/material';
import type { FormEvent, FocusEvent } from 'react';
import { useState } from 'react';
import { requestResetPassword } from '@/entities/session';
import { Analytics } from '@/shared/lib';
import { Button, Input, Label, Loader } from '@/shared/ui';

export function RequestNewLink() {
  const [recipient, setRecipient] = useState('');
  const [inputErrorMessage, setInputErrorMessage] = useState('');
  const [requestErrorMessage, setRequestErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleInputChange = () => {
    setInputErrorMessage('');
  };
  const handleInputBlur = (event: FocusEvent<HTMLInputElement>) => {
    if (!event.target.validity.valid) {
      setInputErrorMessage('Please, enter a valid email.');
    }
  };
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const formElement = event.currentTarget;

    if (!formElement.checkValidity()) {
      return;
    }

    const formData = new FormData(formElement);
    const email = formData.get('email') as string;

    setLoading(true);
    setRequestErrorMessage('');
    requestResetPassword(email)
      .then(() => {
        setRecipient(email);
      })
      .catch((error: Error) => {
        setRequestErrorMessage(
          error.message || 'Something went wrong. Please, try again',
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleErrorClose = () => {
    setRequestErrorMessage('');
  };
  const reportRequestNewAuthLinkUsage = () => {
    Analytics.sendFeatureUsage('expired_auth_link', 'request_new_link');
  };

  if (recipient) {
    return (
      <Alert severity="success">
        Email successfully sent to <b>{recipient}</b>
      </Alert>
    );
  }

  return (
    <Box
      component="form"
      sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
      onSubmit={handleSubmit}
    >
      {requestErrorMessage && (
        <Alert severity="error" onClose={handleErrorClose}>
          {requestErrorMessage}
        </Alert>
      )}
      <Label text="Email">
        <Input
          sx={{
            '& .MuiFormHelperText-root': {
              mx: 0,
            },
          }}
          autoFocus
          required
          type="email"
          placeholder="your@email.com"
          name="email"
          autoComplete="email"
          error={!!inputErrorMessage}
          helperText={inputErrorMessage}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
        />
      </Label>
      <Button
        disabled={loading}
        type="submit"
        onClick={reportRequestNewAuthLinkUsage}
      >
        Send New Link
      </Button>
      <Loader active={loading} />
    </Box>
  );
}
